import { Stack, Typography } from '@mui/material';
import { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@mui/material';
import { MouseEventHandler } from 'react';

export const TableHeader: FC<ITableHeader> = ({
  icon,
  title,
  isAllDataShown,
  dataLength,
  isRecordsWhichOverwrites,
  isDuplicates,
  shownDataLength,
  importButtonAvailable,
  onImport,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          mb: '8px',
        }}
      >
        {icon}
        <Typography
          variant='h4'
          sx={{
            marginTop: '8px',
            marginLeft: '8px',
            fontSize: '18px',
            fontWeight: '500',
            lineHeight: '21.94px',
          }}
        >
          {title}
        </Typography>
        {!isAllDataShown && (
          <Typography
            variant='h4'
            sx={{
              marginTop: '10px',
              marginLeft: '8px',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '21.94px',
            }}
          >
            {`(${t('common.shown')}: ${shownDataLength}/${dataLength})`}
          </Typography>
        )}
        {isRecordsWhichOverwrites && (
          <Alert
            severity='info'
            sx={{
              marginLeft: '8px',
              height: 36,
              paddingLeft: 2,
              paddingRight: 2,
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            {t('settings.some_existing_records_will_be_overwrited')}
          </Alert>
        )}
        {isDuplicates && (
          <Alert
            severity='warning'
            sx={{
              marginLeft: '8px',
              height: 36,
              paddingLeft: 2,
              paddingRight: 2,
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            {t('settings.there_are_some_duplicates_in_import_data')}
          </Alert>
        )}
      </Stack>
      <Button
        sx={{ minWidth: '100px', marginTop: '8px', marginBottom: '8px' }}
        variant='contained'
        color='primary'
        size='small'
        disabled={!importButtonAvailable}
        onClick={onImport}
      >
        {t('debitor.paymentsDetailsInfo.import')}
      </Button>
    </Stack>
  );
};

interface ITableHeader {
  icon: JSX.Element;
  title: string;
  dataLength?: number;
  shownDataLength?: number;
  isAllDataShown: boolean;
  isRecordsWhichOverwrites: boolean;
  isDuplicates: boolean;
  onImport: MouseEventHandler<HTMLButtonElement> | undefined;
  importButtonAvailable: boolean;
}
